export { TabSelector } from './tab-selector';
